module.exports = __webpack_public_path__ + "static/media/trash-outline.7faf5ed0.svg";